import { useIntl } from 'react-intl';
import { Box, Button, Link } from '@packages/shared';
import type { MessageDescriptor } from 'react-intl';
import type { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import type { Flags } from '@packages/config/src/default';
import type { GeoCountryAlternativesType } from './types';
import { messages } from './GeoCountryLayer.messages';
import { GeoCountryFlag } from './GeoCountryLayer.flag';

const useDynamicMessageFormatter = () => {
  const { formatMessage: fm } = useIntl();

  const formatDynamicMessage = (
    descriptor: MessageDescriptor,
    country?: Flags,
    values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>,
  ): string => {
    const messageId = country ? `${descriptor.id}.${country}` : descriptor.id;
    return fm({ id: messageId, defaultMessage: descriptor.defaultMessage }, values);
  };
  return { formatDynamicMessage };
};

export const GeoCountryAlternatives = ({
  alternatives,
  closeLayer,
}: GeoCountryAlternativesType) => {
  const { formatDynamicMessage } = useDynamicMessageFormatter();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
      {alternatives?.map((alternativeShop) => (
        <Box key={alternativeShop.flag} sx={{ mb: 4 }}>
          {alternativeShop.shops &&
            alternativeShop.shops.length &&
            formatDynamicMessage(messages.description, alternativeShop.flag)}
          {alternativeShop?.shops?.map((alt, index) => (
            <Button
              // eslint-disable-next-line react/no-array-index-key
              key={`${alt.link}-${index}`}
              size="large"
              href={alt.link}
              onClick={() => {
                if (alt.closeLayer) closeLayer?.();
              }}
              sx={{ mt: 2, justifyContent: 'space-between' }}
              fullWidth
              LinkComponent={Link}
              endIcon={<GeoCountryFlag flag={alternativeShop.flag} />}
            >
              {formatDynamicMessage(messages.button, alternativeShop.flag, {
                link: alt.title,
              })}
            </Button>
          ))}
        </Box>
      ))}
    </Box>
  );
};
